export default "__VITE_ASSET__f_0hYEsT__"